import React from 'react';
import { useAlert } from 'react-alert';
import BurgerMenu from '../../../commons/BurgerMenu';
import {
  Col,
  CustomInput,
  Form,
  FormGroup,
  Label,
  Row,
  TabContent,
  TabPane,
} from 'reactstrap';
import Header from '../../../commons/Header';
import {
  ContFilterYear,
  ContFlexBetween,
  ContPaginationPage,
} from '../../../styled-components';
import generatePaginationOptions from '../../../lib/helpers/generatePaginationOptions';
import Footer from '../../../commons/Footer';
import { useTranslation } from 'react-i18next';
import { ReactComponent as IconProfile } from '../../../images/icn_profilo.svg';
import NetworkTable from './NetworkTable';
import {
  AdminTypes,
  AgencyTypes,
  ProfileStatus,
  ProfileTypes,
} from '../../../lib/constants';
import SearchInput from '../../../commons/SearchInput';
import { USER_ADMIN_TYPES } from '../../../App';
import NetworkTableBackoffice from './NetworkTableBackoffice';
import generateYearOptions from '../../../lib/helpers/generateYearOptions';

const NetworkPresentational = ({
  data,
  total,
  query,
  onFilter,
  userType = '',
}) => {
  const [t] = useTranslation('ALBO');
  const { offset, limit } = query;
  const alert = useAlert();

  return (
    <TabContent activeTab={'1'}>
      <TabPane tabId="1">
        <section>
          <Row>
            <Col sm="12" md="4" lg="4">
              <ContFilterYear className="no-width">
                <Row>
                  <Col xs="6">
                    <Label>{t('CONTACTS:TITLE_FILTER_TYPE')}</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="profileType"
                        name="profileType"
                        value={query.type || ''}
                        onChange={(e) => onFilter({ type: e.target.value })}
                      >
                        <option value="">Tutti</option>
                        {[...AgencyTypes, ...AdminTypes, 'UTILIZER'].map(
                          (type) => (
                            <option value={type} key={type}>
                              {t(`CONTACTS:${type}`)}
                            </option>
                          )
                        )}
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>
            <Col sm="12" md="4" lg="4">
              <ContFilterYear className="no-width">
                <Row>
                  <Col xs="6">
                    <Label>{t('COMMON:YEAR')}</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="year"
                        name="year"
                        value={query && query.year}
                        onChange={({ target: { value: year } }) => {
                          onFilter({ year });
                        }}
                      >
                        {generateYearOptions()}
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>
            <Col sm="12" md="4" lg="4">
              <SearchInput
                onFilter={onFilter}
                query={query}
                label={t('COMMON:SEARCH')}
              />
            </Col>
          </Row>
        </section>

        <section className="m-t-20">
          {(userType === USER_ADMIN_TYPES.SUPER_ADMIN && (
            <NetworkTable
              data={data}
              total={total}
              offset={offset}
              limit={limit}
              onFilter={onFilter}
            />
          )) || (
            <NetworkTableBackoffice
              data={data}
              total={total}
              offset={offset}
              limit={limit}
              onFilter={onFilter}
            />
          )}

          <ContPaginationPage>
            <p>{t('COMMON:PAGINATION_PER_PAGE')}</p>

            <FormGroup>
              <CustomInput
                type="select"
                className="pagination-select"
                id="perPage"
                name="perPage"
                value={limit}
                onChange={({ target: { value: limit } }) => {
                  onFilter({ limit: limit });
                }}
              >
                {generatePaginationOptions()}
              </CustomInput>
            </FormGroup>
          </ContPaginationPage>
        </section>
        <Footer />
      </TabPane>
    </TabContent>
  );
};

export default NetworkPresentational;
